<template>
  <smart-chart-card :title="title" :is-loading="isLoading" :selectors="[areaGroupSelector, accountSelector, unitSelector]" :charts="charts" @set-period="getData" /></template>
<script>
    import SmartChartCard from '@hw-ui/components/charts/SmartChartCard.vue'
    import { functions, auth } from '@/shared/services/firebase'
    import axios from '@hw-core/libs/axios'
    import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
  
  
    
    export default {
      components: {
        SmartChartCard,
      },
      props: {
        title: {
          type: String,
          default: '',
        },
        endPoint: {
          type: String,
          default: '',
        },
        },
      data() {
        return {
          isLoading: false,
          charts: [],
          areaGroupSelector: {
            title: 'Valitse alue',
            id: 0,
            width: '200px',
            selectorOptions: {
              clearable: false,
              multiple: false,
            },
            options: [{
              label: 'Kaikki',
              value: null,
            }, ...this.$store.state.appAccount.areaGroups.map(areaGroup => ({
              label: areaGroup.groupName,
              value: areaGroup.id
            }))],
            selected: this.$store.state.appAccount.areaGroups.find(areaGroup => areaGroup.id === this.$store.state.appAuth.authUser.id)?.id || null,
          },
          accountSelector: {
            title: 'Valitse asiakas',
            id: 1,
            width: '200px',
            selectorOptions: {
              clearable: false,
              multiple: false,
            },
            options: this.$store.state.appAccount.accounts.map(account => ({
              label: account.label,
              value: account.value.id
            })),
            selected: null,
          },
          unitSelector: {
            title: 'Yksikkö',
            id: 2,
            width: '100px',
            selectorOptions: {
              clearable: false,
              multiple: false,
            },
            options: [
              {
                label: 'Kpl',
                value: 'kpl',
              },
              {
                label: 'Eur',
                value: 'eur',
              },
            ],
            selected: 'kpl',
            default: 'kpl'
          },
        }
      },
      methods: {
        async getData({
          period,
          selected,
          force,
          interval,
        }) {
          this.isLoading = true
          this.charts = []
          this.accountSelector.options = this.$store.state.appAccount.accounts.map(account => ({
              label: account.label,
              value: account.value.id
            }))
          let accountIds = []
          const areaIds = []
          try {
          const idToken = await auth.currentUser.getIdToken(true)
          const { startDate, endDate } = period
          const [selectedGroup, selectAccount, selectedUnit] = selected
          // Filter accounts and areas based on group and set selectors on UI
          if(selectedGroup) {
            const {areaGroups} = this.$store.state.appAccount
            const group = areaGroups.find(g => g.id === selectedGroup)
            group.accounts.forEach(account => {
              accountIds.push(account)
            })
            group.areas.forEach(area => {
              areaIds.push(area)
            })
            this.accountSelector.options = this.$store.state.appAccount.accounts.filter(account => accountIds.includes(account.value.id)).map(account => ({
              label: account.label,
              value: account.value.id
            }))
          }
          if(selectAccount) { // If one account is selected, filter areas based on account
            accountIds = [selectAccount]
          }
          const response = await axios
            .post(`${functions.url}/${this.endPoint}`, {
              token: idToken,
              startDate: startDate.toDate(),
              endDate: endDate.toDate(),
              accountIds,
              areaIds,
              unit: selectedUnit,
              force,
              interval,
            })
          if(response.data.charts?.length > 0) {
            this.charts = response.data.charts
          }
          } catch (error) {
              this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('error'),
                text: 'Virhe datan hakemisessa',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
            this.isLoading = false
          }
          this.isLoading = false
        },
      },
    }
    </script>
    
    <style lang="scss">
    @import "@hw-ui/scss/vue/libs/vue-flatpicker.scss";
    </style>
    
    <style lang="scss" scoped>
    ::v-deep .weeks-dropdown {
      background-color: pink;
      .dropdown-menu {
        max-height: 300px;
        overflow-y: auto;
      }
    }
    </style>
    